// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1prln","right":"styles_right__2NQ4g"};